/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Element as ScrollElement } from 'react-scroll';
import {
  setPos, getOaActivities, getActivitiesByTypeAndDate, setActiveOa,
} from '../../actions';
import { getDistanceInKm, maskPhone, isMobile } from '../../utils/helpers';

import logoAmorc from '../../assets/ordem-rosacruz-amorc-cinza.png';
import logoTom from '../../assets/tom-cinza.png';


class OasList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      oas: [],
    };
  }

  componentWillMount() {
    const sorted = this.sortByDistance(this.props.oas);
    if (sorted !== this.state.oas) {
      this.setState({ oas: sorted }, () => {
        const first = this.state.oas[0];
        if (!isMobile() && first) {
          this.handleOaClick(first.num_latitu, first.num_longit, first);
        }
      });
    }
  }

  async handleOaClick(lat, lng, oa) {
    await this.props.setActiveOa(oa);
    await this.props.setPos(lat, lng, oa);
    await this.props.history.push(`/oa/${oa.seq_cadast}`);
    this.props.getActivitiesByTypeAndDate();
  }

  sortByDistance(oasList) {
    const { userLat, userLng } = this.props;

    oasList.sort((a, b) => {
      const distanceA = getDistanceInKm(userLat, userLng, a.num_latitu, a.num_longit);
      const distanceB = getDistanceInKm(userLat, userLng, b.num_latitu, b.num_longit);
      return Math.floor(distanceA) < Math.floor(distanceB) ? -1 : 1;
    });


    return oasList;
  }


  render() {
    const { props } = this;

    if (this.state.length === 0) {
      return (
        <div className="search-result">
          <h2>
            Nenhum organismo afiliado foi encontrado com os dados informados.
            <br />
            Verifique os filtros e realize uma nova busca
          </h2>
        </div>
      );
    }

    return (
      <>
        {this.state.oas.length === 0 ? (
          <div className="search-result">
            <h2>
              Nenhum organismo afiliado foi encontrado com os dados informados.
              <br />
              Verifique os filtros e realize uma nova busca
            </h2>
          </div>
        ) : this.state.oas.map((oa) => (
          <ScrollElement key={Math.random()} name={`oa-${oa.seq_cadast}`}>
            <div
              className={`oa ${this.props.activeOa.seq_cadast === oa.seq_cadast && 'active'}`}
              onClick={() => this.handleOaClick(
                parseFloat(oa.num_latitu),
                parseFloat(oa.num_longit),
                oa,
              )}
              role="presentation"
            >
              <div className="oa-image">
                <img src={oa.ide_tipo_oa === 'H' ? logoTom : logoAmorc} alt="Imagem AMORC" />
              </div>
              <div className="oa-infos">
                <h2>{oa.nom_client}</h2>
                <p>
                  {`${oa.des_lograd}, ${oa.num_endere !== null ? oa.num_endere : ''}
                        - 
                        ${oa.nom_locali}/${oa.sig_uf !== '**' ? oa.sig_uf : oa.sig_pais_endere}`}
                </p>
                {oa.num_telefo_fixo !== null ? (
                  <a className="oa-tel" href={`tel:${oa.num_telefo_fixo}`}>{maskPhone(oa.num_telefo_fixo)}</a>
                ) : ''}
              </div>
              <div>
                <p className="oa-distance">
                  {
                    getDistanceInKm(
                      props.userLat,
                      props.userLng,
                      oa.num_latitu,
                      oa.num_longit,
                    )
                  }
                  {' '}
                  Km
                </p>
              </div>
            </div>
          </ScrollElement>
        ))}
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  oas: store.oasState.oas,
  activeOa: store.oasState.activeOa,
  lat: store.mapState.lat,
  lng: store.mapState.lng,
  userLat: store.mapState.userLat,
  userLng: store.mapState.userLng,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
  setPos, getOaActivities, getActivitiesByTypeAndDate, setActiveOa,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OasList);
